// Frontend Orchestration Module
// Moved from backend orchestrationModule.js to frontend

const regions = {
    Global: "Global",
    India: "India",
    USA: "United States",
    UAE: "United Arab Emirates",
    Australia: "Australia",
    Global_Selfie: "Face Verification"
};

const flowTypes = {
	basicKYC: "Basic KYC",
	mediumKYC: "Medium KYC",
	advanceKYC: "Advance KYC"
};

/**
 * Hard ceiling on the documents one journey can capture.
 *
 * one-journey-backend models exactly three document slots (documentIntelligence,
 * documentIntelligence2, documentIntelligence3, and the matching idType/userDetails/
 * externalApiResponses fields). A fourth configured document would be captured from the
 * applicant and then silently dropped, so it is refused here instead.
 */
const MAX_DOCUMENT_ITERATIONS = 3;

const blockNames = {
    instruction: "instruction",
    countrySelection: "countrySelection",
    userDetails: "userDetails",
    documentSelection: "documentSelection",
    documentCapture: "documentCapture",
    noDocumentCapture: "noDocumentCapture",
    faceCapture: "faceCapture",
    complete: "complete",
    mobileFlow: "mobileFlow",
    expired: "expired",
    error: "error",
    faq: "faq",
    phoneAndEmailCheck: "phoneAndEmailCheck",
    supportingDocument: "supportingDocument"
};

const journeyConfig = {
    [regions.Global]: {
        [flowTypes.basicKYC]: {
            preDocumentSteps: [blockNames.instruction, blockNames.countrySelection, blockNames.userDetails],
            documentIterations: 1,
            documentSteps: [blockNames.documentSelection, blockNames.documentCapture],
            postDocumentSteps: [blockNames.faceCapture, blockNames.complete, blockNames.mobileFlow, blockNames.faq, blockNames.expired, blockNames.error]
        },
        [flowTypes.mediumKYC]: {
            preDocumentSteps: [blockNames.instruction, blockNames.countrySelection, blockNames.userDetails],
            documentIterations: 1,
            documentSteps: [blockNames.documentSelection, blockNames.documentCapture],
            postDocumentSteps: [blockNames.faceCapture, blockNames.complete, blockNames.mobileFlow, blockNames.faq, blockNames.expired, blockNames.error]
        },
        [flowTypes.advanceKYC]: {
            preDocumentSteps: [blockNames.instruction, blockNames.countrySelection, blockNames.userDetails],
            documentIterations: 2,
            documentSteps: [blockNames.documentSelection, blockNames.documentCapture],
            postDocumentSteps: [blockNames.faceCapture, blockNames.complete, blockNames.mobileFlow, blockNames.faq, blockNames.expired, blockNames.error]
        }
    },
    [regions.Global_Selfie]: {
        [flowTypes.basicKYC]: {
            preDocumentSteps: [blockNames.instruction],
            documentIterations: 0,
            documentSteps: [],
            postDocumentSteps: [blockNames.faceCapture, blockNames.complete, blockNames.mobileFlow, blockNames.faq, blockNames.expired, blockNames.error]
        }
    },
    [regions.India]: {
        [flowTypes.basicKYC]: {
            preDocumentSteps: [blockNames.instruction, blockNames.countrySelection, blockNames.userDetails],
            documentIterations: 1,
            documentSteps: [blockNames.documentSelection, blockNames.documentCapture],
            noDocumentSteps: [blockNames.documentSelection, blockNames.noDocumentCapture],
            postDocumentSteps: [blockNames.faceCapture, blockNames.complete, blockNames.mobileFlow, blockNames.faq, blockNames.expired, blockNames.error]
        },
        [flowTypes.mediumKYC]: {
            preDocumentSteps: [blockNames.instruction, blockNames.countrySelection, blockNames.userDetails],
            documentIterations: 1,
            documentSteps: [blockNames.documentSelection, blockNames.documentCapture],
            noDocumentSteps: [blockNames.documentSelection, blockNames.noDocumentCapture],
            postDocumentSteps: [blockNames.faceCapture, blockNames.complete, blockNames.mobileFlow, blockNames.faq, blockNames.expired, blockNames.error]
        },
        //in india first document can be PAN(with both OCR and panFetch option) , second doc can be aadhaar(with both OCR and digilocker option), third doc can be utility bill
        [flowTypes.advanceKYC]: {
            preDocumentSteps: [blockNames.instruction, blockNames.countrySelection, blockNames.userDetails, blockNames.phoneAndEmailCheck],
            documentIterations: 2, // Number of documents to analyze
            documentSteps: [blockNames.documentSelection, blockNames.documentCapture],
            noDocumentSteps: [blockNames.documentSelection, blockNames.noDocumentCapture],
            postDocumentSteps: [blockNames.faceCapture, blockNames.complete, blockNames.mobileFlow, blockNames.faq, blockNames.expired, blockNames.error]
        }
    },
    [regions.USA]: {
        [flowTypes.basicKYC]: {
            preDocumentSteps: [blockNames.instruction, blockNames.countrySelection, blockNames.userDetails],
            documentIterations: 1,
            documentSteps: [blockNames.documentSelection, blockNames.documentCapture],
            postDocumentSteps: [blockNames.faceCapture, blockNames.complete, blockNames.mobileFlow, blockNames.faq, blockNames.expired, blockNames.error]
        },
        [flowTypes.mediumKYC]: {
            preDocumentSteps: [blockNames.instruction, blockNames.countrySelection, blockNames.userDetails],
            documentIterations: 1,
            documentSteps: [blockNames.documentSelection, blockNames.documentCapture],
            postDocumentSteps: [blockNames.faceCapture, blockNames.complete, blockNames.mobileFlow, blockNames.faq, blockNames.expired, blockNames.error]
        },
        [flowTypes.advanceKYC]: {
            preDocumentSteps: [blockNames.instruction, blockNames.countrySelection, blockNames.userDetails, blockNames.phoneAndEmailCheck],
            documentIterations: 3,
            documentSteps: [blockNames.documentSelection, blockNames.documentCapture],
            postDocumentSteps: [blockNames.faceCapture, blockNames.complete, blockNames.mobileFlow, blockNames.faq, blockNames.expired, blockNames.error]
        }
    },
    [regions.Australia]: {
        [flowTypes.basicKYC]: {
            preDocumentSteps: [blockNames.instruction, blockNames.countrySelection, blockNames.userDetails],
            documentIterations: 1,
            documentSteps: [blockNames.documentSelection, blockNames.documentCapture],
            postDocumentSteps: [blockNames.faceCapture, blockNames.complete, blockNames.mobileFlow, blockNames.faq, blockNames.expired, blockNames.error]
        },
        [flowTypes.mediumKYC]: {
            preDocumentSteps: [blockNames.instruction, blockNames.countrySelection, blockNames.userDetails],
            documentIterations: 1,
            documentSteps: [blockNames.documentSelection, blockNames.documentCapture],
            postDocumentSteps: [blockNames.faceCapture, blockNames.complete, blockNames.mobileFlow, blockNames.faq, blockNames.expired, blockNames.error]
        },
    },
    [regions.UAE]: {
        [flowTypes.basicKYC]: {
            preDocumentSteps: [blockNames.instruction, blockNames.countrySelection, blockNames.userDetails],
            documentIterations: 1,
            documentSteps: [blockNames.documentSelection, blockNames.documentCapture],
            postDocumentSteps: [blockNames.faceCapture, blockNames.complete, blockNames.mobileFlow, blockNames.faq, blockNames.expired, blockNames.error]
        },
        [flowTypes.mediumKYC]: {
            preDocumentSteps: [blockNames.instruction, blockNames.countrySelection, blockNames.userDetails],
            documentIterations: 1,
            documentSteps: [blockNames.documentSelection, blockNames.documentCapture],
            postDocumentSteps: [blockNames.faceCapture, blockNames.complete, blockNames.mobileFlow, blockNames.faq, blockNames.expired, blockNames.error]
        },
        //advanceKYC is such as user can pass EId in first documentCapture and in second we can have internationalPassport option
        [flowTypes.advanceKYC]: {
            preDocumentSteps: [blockNames.instruction, blockNames.countrySelection, blockNames.userDetails, blockNames.phoneAndEmailCheck],
            documentIterations: 3,
            documentSteps: [blockNames.documentSelection, blockNames.documentCapture],
            postDocumentSteps: [blockNames.faceCapture, blockNames.complete, blockNames.mobileFlow, blockNames.faq, blockNames.expired, blockNames.error]
        }
    },
    [regions.ICP]: {
        [flowTypes.UAE]: {
            preDocumentSteps: [blockNames.instruction, blockNames.userDetails],
            documentIterations: 2,
            documentSteps: [blockNames.countrySelection, blockNames.documentSelection, blockNames.documentCapture],
            postDocumentSteps: [blockNames.faceCapture, blockNames.complete, blockNames.mobileFlow, blockNames.faq, blockNames.expired, blockNames.error]
        },
        [flowTypes.gulfCountries]: {
            preDocumentSteps: [blockNames.instruction, blockNames.countrySelection, blockNames.userDetails],
            documentIterations: 2,
            documentSteps: [blockNames.documentSelection, blockNames.documentCapture],
            postDocumentSteps: [blockNames.faceCapture, blockNames.complete, blockNames.mobileFlow, blockNames.faq, blockNames.expired, blockNames.error]
        }
    }
};

const blockRoutes = {
	[blockNames.instruction]: [
		{
			route: `/{journeyId}{urlParams}`,
			onSuccess: "1",
			onFailure: "error",
			onBack: null
		}
	],
	[blockNames.countrySelection]: [
		{
			route: `/{journeyId}/country{urlParams}`,
			onSuccess: "1",
			onFailure: "error",
			onBack: "0"
		}
	],
	[blockNames.userDetails]: [
		{
			route: `/{journeyId}/userDetails{urlParams}`,
			onSuccess: "1",
			onFailure: "error",
			onBack: "0"
		}
	],
	[blockNames.phoneAndEmailCheck]: [
		{
			route: `/{journeyId}/phoneAndEmailCheck{urlParams}`,
			onSuccess: "1",
			onFailure: "error",
			onBack: "0"
		}
	],
	[blockNames.documentSelection]: [
		{
			route: `/{journeyId}/documents{urlParams}`,
			onSuccess: "1",
			onFailure: "error",
			onBack: "0"
		},
		{
			route: `/{journeyId}/verificationType{urlParams}`,
			onSuccess: "1",
			onFailure: "error",
			onBack: "0"
		}
	],
	[blockNames.documentCapture]: [
		{
			route: `/{journeyId}/camera{urlParams}`,
			onSuccess: "1",
			onFailure: "error",
			onBack: "0"
		},
		{
			route: `/{journeyId}/front{urlParams}`,
			onSuccess: "1",
			onFailure: "error",
			onBack: "-1"
		},
		{
			route: `/{journeyId}/front/check{urlParams}`,
			onSuccess: "1",
			onFailure: "error",
			onBack: "0"
		},
		{
			route: `/{journeyId}/back{urlParams}`,
			onSuccess: "1",
			onFailure: "error",
			onBack: "0"
		},
		{
			route: `/{journeyId}/back/check{urlParams}`,
			onSuccess: "1",
			onFailure: "error",
			onBack: "0"
		},
		{
			route: `/{journeyId}/analysis{urlParams}`,
			onSuccess: "2",
			onFailure: "1",
			onBack: null
		},
		{
			route: `/{journeyId}/unable-to-process{urlParams}`,
			onSuccess: "documentCapture",
			onFailure: "docSelection",
			onBack: "-2"
		}
	],
    [blockNames.noDocumentCapture]: [
        {
            route: `/{journeyId}/user-details{urlParams}`,
            onSuccess: '1',
            onFailure: 'error',
            onBack: '0'
        },
        {
            route: `/{journeyId}/analysis{urlParams}`,
            onSuccess: '2',
            onFailure: '1',
            onBack: null
        },
        {
            route: `/{journeyId}/unable-to-process{urlParams}`,
            onSuccess: 'noDocumentCapture',
            onFailure: 'docSelection',
            onBack: '-2'
        }
    ],
	[blockNames.supportingDocument]: [
		{
			route: `/{journeyId}/supporting-document{urlParams}`,
			onSuccess: "1",
			onFailure: "error",
			onBack: "0"
		}
	],
	[blockNames.faceCapture]: [
		{
			route: `/{journeyId}/liveness/instruction{urlParams}`,
			onSuccess: "1",
			onFailure: "error",
			onBack: null
		},
		{
			route: `/{journeyId}/liveness{urlParams}`,
			onSuccess: "1",
			onFailure: "error",
			onBack: "0"
		}
	],
	[blockNames.complete]: [
		{
			route: `/{journeyId}/complete{urlParams}`,
			onSuccess: null,
			onFailure: null,
			onBack: null
		}
	],
	[blockNames.faq]: [
		{
			route: `/{journeyId}/faq{urlParams}`,
			onSuccess: null,
			onFailure: null,
			onBack: null
		}
	],
	[blockNames.mobileFlow]: [
		{
			route: `/{journeyId}/enable-mobile-flow{urlParams}`,
			onSuccess: null,
			onFailure: null,
			onBack: null
		}
	],
	[blockNames.expired]: [
		{
			route: `/{journeyId}/expired{urlParams}`,
			onSuccess: null,
			onFailure: null,
			onBack: null
		}
	],
	[blockNames.error]: [
		{
			route: `/{journeyId}/error{urlParams}`,
			onSuccess: null,
			onFailure: null,
			onBack: null
		}
	]
};

// The camera-permission page. It is normally the first page of the documentCapture block; this
// standalone copy is inserted for journeys that reach face capture without ever entering that
// block. Also the only screen that asks for the applicant's location, so a journey without it
// silently ignores `config.userSettings.allowLocation`.
const cameraAccessPage = {
	route: `/{journeyId}/camera{urlParams}`,
	onSuccess: "1",
	onFailure: "error",
	onBack: "0"
};

/**
 * Generates an orchestration object with a routes property that contains all the URLs
 * for the workflow. The orchestration object is generated based on the given region and
 * flowType from the journeyConfig object. The routes are built by iterating over the
 * preDocumentSteps, documentSteps and postDocumentSteps and adding the routes from each
 * step to the routes object. The routes are added to the routes object in the order that
 * they appear in the steps array. The steps that are not required according to the config
 * object are skipped. The exception is verificationType which is only added for
 * documentSelection for non-Global region. The first page of faceCapture is skipped if
 * instructionPage is false in the config.
 * The navigation rules are:
 * - onSuccess: The route to redirect to on success.
 * - onFailure: The route to redirect to on failure.
 * - onBack: The route to redirect to on back button click.
 * The orchestration object is used by the client to navigate to the correct
 * route based on the state of the flow.
 * @param {string} region - The region of the flow.
 * @param {string} flowType - The type of the flow.
 * @param {Object} config - The configuration object of the flow.
 * @param {...(string|undefined)} verificationTypes - How each captured document is being verified,
 * in document order: verificationTypes[0] for document 1, [1] for document 2, and so on. A
 * document with no entry is verified the normal way (camera capture); 'NO_DOC' routes it through
 * the no-document flow (Digilocker / PAN Verification) instead. Taking these as a rest parameter
 * rather than two named arguments means a third document needs no signature change, and every
 * existing two-argument caller keeps working untouched.
 * @returns {Object} An orchestration object with two properties: routes and navigation.
 * The routes property is an object where the keys are the step names and the values are the corresponding routes.
 * The navigation property is an object where the keys are the step names and the values are objects with three properties: onSuccess, onFailure and onBack.
 */
function createOrchestration(region, flowType, config, ...verificationTypes) {
    console.log('[orchestrationModule][createOrchestration] Running orchestration module in frontend', verificationTypes);
    const blocks = journeyConfig[region][flowType];
    if (!blocks) {
        throw new Error(`Invalid region or flow type: ${region}, ${flowType}`);
    }
    const routes = {};
    const navigation = {};
    let currentIndex = 0;
    const isOnlySelfieFlow = region === regions.Global_Selfie;


    // How many documents this journey captures.
    //
    // The admin decides this in garuda ("Multi Document Analysis" — Documents 1..3), so the
    // configured documentCapture entries are the source of truth. journeyConfig's
    // documentIterations is only the floor a flow ships with: without it, a flow whose config
    // has not been re-saved since the tab UI shipped would capture nothing.
    //
    // Capped at MAX_DOCUMENT_ITERATIONS because one-journey-backend models exactly three
    // document slots (documentIntelligence / 2 / 3) — a fourth would be captured and silently
    // dropped.
    // Selfie-only flows capture no documents at all (documentIterations: 0). They still carry a
    // vestigial documentCapture entry in their saved config, so they must be excluded explicitly
    // rather than by counting it.
    const configuredDocuments = Array.isArray(config?.documentCapture)
        ? config.documentCapture.length
        : 0;
    const totalIteration = blocks?.documentIterations === 0
        ? 0
        : Math.min(
            Math.max(configuredDocuments, blocks?.documentIterations ?? 0),
            MAX_DOCUMENT_ITERATIONS
        );

    // Every document asks for its own country (IDX-677). A flow configures a country list per
    // document, so the applicant answers it per document — the same question is put once for each
    // document rather than once for the journey, whether or not the lists happen to match.
    //
    // Regions that never ask up front are left alone: a flow with no country screen does not gain
    // one, and a region that already asks per document (its documentSteps carry countrySelection)
    // is already in the shape this produces.
    //
    // Global only. Every other region carries countrySelection in preDocumentSteps too, so
    // without this gate India, the United States, the UAE and Australia would each go from one
    // country screen to one per document as well. They configure documents `documentWise` in the
    // flow builder — no Countries step, no per-slot country list — so their slots cannot be
    // differentiated by an admin at all. Splitting the screen there offers the applicant the same
    // list three times and no new choice: two extra taps, nothing gained. IDX-677 is scoped to
    // Global; this keeps it there.
    const isCountryPerDocument =
        region === regions.Global &&
        Boolean(blocks?.preDocumentSteps?.includes(blockNames.countrySelection));
    // Document 1's country screen stays where it always was — up front in preDocumentSteps, ahead
    // of the userDetails (PAN) form — so a single-document Global flow is byte-identical to
    // pre-IDX-677 and an applicant is never asked for a PAN before stating a country. Only
    // documents 2 and 3 gain a country screen of their own, injected into the capture loop below;
    // that is the only place per-document country adds a question (D5 still holds — every document
    // owns its list; document 1's is simply asked up front).
    const preDocumentSteps = blocks?.preDocumentSteps;
    // Prepend the country screen to a document's steps only from the SECOND document on
    // (iteration > 0); document 1 already asked up front. noDocumentSteps is wrapped for symmetry
    // but dormant today — Global defines none, and the regions that do are never
    // isCountryPerDocument.
    const withCountryStep = (steps, iteration) =>
        isCountryPerDocument && iteration > 0 && Array.isArray(steps) && !steps.includes(blockNames.countrySelection)
            ? [blockNames.countrySelection, ...steps]
            : steps;

    // steps before documentAnalysis
    preDocumentSteps?.forEach((step, index) => {
        console.log('[orchestrationModule][createOrchestration] Pre document steps', step);
        if (config[step]?.required === false || (isOnlySelfieFlow && index > 0)) {
            return;
        }
        // Skip intro page (instruction block) for selfie-only flow when instructionPage is false
        if (isOnlySelfieFlow && step === blockNames.instruction && config?.faceCapture?.instructionPage === false) {
            return;
        }
        const blockRouteArray = blockRoutes[step];
        blockRouteArray?.forEach((page) => {
            routes[currentIndex] = page.route;
            navigation[currentIndex] = [
                page.onSuccess,
                page.onFailure,
                page.onBack
            ];
            currentIndex++;
        });
    });

    // IDX-707: Digilocker is a single verification source. One consented session fetches every
    // configured document and the backend fans them across the slots inside ONE DOC_CHECK, so the
    // journey shows exactly one no-document block (redirect + analysing) — never the per-document
    // capture loop below. config.documentCapture is preserved but ignored here (Phase 2 fallback
    // seam). The Document Selection screen is bypassed at runtime (SelectDocument auto-redirects on
    // this route); the block is reused unchanged so the Digilocker round-trip navigation stays
    // identical to today's Aadhaar-only Digilocker flow.
    // IDX-707 #4: a DigiLocker route replaces the per-document capture loop with a single
    // no-document block, which exists only for India (blocks.noDocumentSteps). Guard on its
    // presence so a digilocker=true config that reached a non-India region (via the dashboard
    // validator bypass or a post-enable region switch) falls back to the manual capture loop
    // instead of producing a journey with NO document phase at all.
    const isDigilockerRoute =
        config?.digilocker?.required === true &&
        Array.isArray(blocks?.noDocumentSteps) &&
        blocks.noDocumentSteps.length > 0;
    if (isDigilockerRoute) {
        blocks?.noDocumentSteps?.forEach((step) => {
            const blockRouteArray = blockRoutes[step];
            blockRouteArray?.forEach((page) => {
                if (step === blockNames.documentSelection && page.route.includes('verificationType')) {
                    return;
                }
                routes[currentIndex] = page.route;
                navigation[currentIndex] = [page.onSuccess, page.onFailure, page.onBack];
                currentIndex++;
            });
        });
    }

    let iterations = 0;
    while (!isDigilockerRoute && iterations < totalIteration) {
        const documentSteps = withCountryStep(blocks?.documentSteps, iterations);
        const noDocumentSteps = withCountryStep(blocks?.noDocumentSteps, iterations);
        if (config?.documentCapture?.[iterations]?.required && config?.documentCapture?.[iterations]?.countries?.length) {
            // Each document is verified the way that document was selected. Previously only
            // documents 1 and 2 were mapped, so a third document always fell through to the
            // camera path even when the applicant had chosen Digilocker or PAN Verification.
            const currentVerificationType = verificationTypes[iterations];

            console.log(`[orchestrationModule][createOrchestration] Processing document ${iterations + 1} with verificationType: ${currentVerificationType ?? 'DOC (default)'}`);

            // Different logic based on verification types
            if (currentVerificationType === "NO_DOC") {
                console.log(`[orchestrationModule][createOrchestration] NO_DOC verification detected for iteration ${iterations}, applying NO_DOC logic`);

                // For NO_DOC verification, skip most document steps and add specific routes
                noDocumentSteps?.forEach((step) => {
                    console.log('[orchestrationModule][createOrchestration] No Document steps', step);
                    const blockRouteArray = blockRoutes[step];
                    blockRouteArray?.forEach((page) => {
                        if (step === 'documentSelection' && page.route.includes('verificationType')) {
                            return;  // Skip verificationType for Global region
                        }
                        routes[currentIndex] = page.route;
                        navigation[currentIndex] = [
                            page.onSuccess,
                            page.onFailure,
                            page.onBack
                        ];
                        currentIndex++;
                    });
                });
               
            } else {
                console.log(`[orchestrationModule][createOrchestration] DOC verification detected for iteration ${iterations}, applying normal document logic`);

                // Normal document processing for DOC verification
                documentSteps?.forEach((step) => {
                    console.log('[orchestrationModule][createOrchestration] Document steps', step);
                    if (config[step]?.required === false) {
                        return;
                    }
                    const blockRouteArray = blockRoutes[step];
                    blockRouteArray?.forEach((page) => {
                        // Handle the exception: verificationType only if region is not Global
                        if (step === 'documentSelection' && page.route.includes('verificationType')) {
                            return;  // Skip verificationType for Global region
                        }
                        routes[currentIndex] = page.route;
                        navigation[currentIndex] = [
                            page.onSuccess,
                            page.onFailure,
                            page.onBack
                        ];
                        currentIndex++;
                    });
                });
            } 
        }
        iterations++;
    }

    // Supporting document — captured only, never OCR'd or compared. It is not tied to a region or
    // flow type (any flow may collect one), so it is gated on the config alone rather than living
    // in journeyConfig. It comes after every ID document and before face capture, matching the
    // SUPPORTING_DOC step in one-journey-backend's journey state machine.
    if (config?.supportingDocument?.enabled) {
        console.log('[orchestrationModule][createOrchestration] Supporting document step enabled');
        blockRoutes[blockNames.supportingDocument]?.forEach((page) => {
            routes[currentIndex] = page.route;
            navigation[currentIndex] = [
                page.onSuccess,
                page.onFailure,
                page.onBack
            ];
            currentIndex++;
        });
    }

	// Insert a camera-permission page for any journey that ends in face capture but never produced
	// one of its own.
	//
	// The page normally arrives as the first page of the documentCapture block, so the journeys that
	// skip that block reach the selfie screen having never been asked for camera permission — and,
	// because CameraAccess is also the only place location is requested, never asked for location
	// either. `config.userSettings.allowLocation` was therefore silently ignored on:
	//   - selfie-only flows (no document phase at all) — the case this branch originally covered;
	//   - Digilocker journeys (IDX-707), whose capture loop is replaced by the no-document block;
	//   - journeys whose every document is verified NO_DOC (PAN Verification and the like).
	//
	// Gating on the actual condition — "this journey has face capture and no camera page yet" —
	// covers all three instead of naming flow types one at a time. A journey whose document loop
	// already produced a camera page is untouched, including a mixed journey where only the second
	// document is captured by camera: it was already asked there.
	const hasFaceCapture =
		Boolean(blocks?.postDocumentSteps?.includes(blockNames.faceCapture)) &&
		config?.[blockNames.faceCapture]?.required !== false;
	const hasCameraAccessPage = Object.values(routes).some((route) => route.includes("/camera"));
	if (hasFaceCapture && !hasCameraAccessPage) {
		console.log("[orchestrationModule][createOrchestration] Journey reaches face capture with no camera permission step; inserting one");
		routes[currentIndex] = cameraAccessPage.route;
		navigation[currentIndex] = [cameraAccessPage.onSuccess, cameraAccessPage.onFailure, cameraAccessPage.onBack];
		currentIndex++;
	}

    blocks?.postDocumentSteps?.forEach((step) => {
        console.log('[orchestrationModule][createOrchestration] Post document steps', step);
        if (config[step]?.required === false) {
            return;
        }
        const blockRouteArray = blockRoutes[step];
        blockRouteArray?.forEach((page, index) => {
            // Handle faceCapture instruction page logic (index 0 is the instruction page route)
            // Skip the instruction page in two scenarios:
            // 1. When instructionPage is false: Skip for all flows (instruction page is disabled)
            // 2. When instructionPage is true AND it's a selfie-only flow: Skip because the intro page
            //    (from instruction block) already serves as the instruction page, so showing both would be redundant
            if (step === 'faceCapture' && index === 0) {
                if (config[step]?.instructionPage !== true) {
                    return;  // Skip instruction page when it's disabled
                }
                if (isOnlySelfieFlow && config[step]?.instructionPage === true) {
                    return;  // Skip instruction page for selfie-only flow (intro page already shown)
                }
            }
            if (page.route) {
                routes[currentIndex] = page.route;
                navigation[currentIndex] = [
                    page.onSuccess,
                    page.onFailure,
                    page.onBack
                ];
                currentIndex++;
            }
        });
    });

    // Replace the sequence of document capture routes (front -> front/check -> back -> back/check)
	// with a single consolidated doc-capture route. Do this only when the exact
	// consecutive sequence is present to avoid unintended changes.
	(function consolidateDocumentCaptureSteps() {
		const routeEntries = Object.entries(routes).sort((a, b) => parseInt(a[0]) - parseInt(b[0]));
		const navEntries = Object.entries(navigation).sort((a, b) => parseInt(a[0]) - parseInt(b[0]));

		if (routeEntries.length === 0) return;

		const newRoutes = [];
		const newNavs = [];
		let i = 0;
		while (i < routeEntries.length) {
			const r0 = routeEntries[i]?.[1];
			const r1 = routeEntries[i + 1]?.[1];
			const r2 = routeEntries[i + 2]?.[1];
			const r3 = routeEntries[i + 3]?.[1];

			const isFrontBackSequence =
				typeof r0 === "string" &&
				typeof r1 === "string" &&
				typeof r2 === "string" &&
				typeof r3 === "string" &&
				r0.includes("/front{urlParams}") &&
				r1.includes("/front/check{urlParams}") &&
				r2.includes("/back{urlParams}") &&
				r3.includes("/back/check{urlParams}");

			if (isFrontBackSequence) {
				// Insert consolidated doc-capture route with simple navigation:
				// onSuccess -> next page, onFailure -> error, onBack -> previous page
				newRoutes.push(`/{journeyId}/doc-capture{urlParams}`);
				newNavs.push(["1", "error", "-1"]);
				i += 4; // Skip the consumed sequence
				continue;
			}

			// Otherwise, keep the current route and its navigation as-is
			newRoutes.push(r0);
			newNavs.push(navEntries[i][1]);
			i += 1;
		}

		// Rebuild routes and navigation with consolidated entries while preserving indices
		Object.keys(routes).forEach((key) => delete routes[key]);
		Object.keys(navigation).forEach((key) => delete navigation[key]);
		for (let idx = 0; idx < newRoutes.length; idx++) {
			routes[idx] = newRoutes[idx];
			navigation[idx] = newNavs[idx];
		}
	})();

	Object.keys(navigation).forEach((route) => {
		navigation[route][0] = handleNextStepOnSuccess(route, routes, navigation[route][0]);
		navigation[route][1] = handlePrevStepOnFailure(route, routes, navigation[route][1]);
		navigation[route][2] = handleStepOnBack(route, routes, navigation[route][2]);
	});

	console.log("[orchestrationModule][createOrchestration] Routes", routes);
	console.log("[orchestrationModule][createOrchestration] Navigation", navigation);

	return { routes, navigation };
}


function findNextStep(currentStepIndex, keyword, steps) {
  const keys = Object.keys(steps).map(Number);
  let i = currentStepIndex!=0 ? currentStepIndex-1 : 0;
  for ( ; i < keys.length; i++) {
    const step = steps[i];
    if (step.includes(`/${keyword}`)) {
      return i; // return first match
    }
  }
  return 0; // not found
}

/**
 * Handles the next step based on the onSuccess value.
 * @param {number} currentIndex - The current index of the route
 * @param {Object} routes - The routes object
 * @param {string} onSuccess - The value of onSuccess
 * @returns {number|string|null} The next index of the route. If onSuccess is 'error', returns 'error'. If onSuccess is not recognized, returns null.
 */
function handleNextStepOnSuccess(currentIndex, routes, onSuccess) {
	switch (onSuccess) {
		case "1":
			return parseInt(currentIndex) + 1;
		case "2":
			return parseInt(currentIndex) + 2;
		case "documentCaptureOrFaceCapture": {
			const livenessRoute = Object.entries(routes).find(([key, value]) => value.includes("liveness"));
			return parseInt(livenessRoute[0]);
		}
		case "documentCapture": {
			const documentCaptureRoute = findLastRoute(routes, currentIndex, "camera");
			return parseInt(documentCaptureRoute[0]);
		}
		case "noDocumentCapture": {
			const detailsRoute = findLastRoute(routes, currentIndex, "user-details");
			return detailsRoute ? parseInt(detailsRoute[0]) : null;
		}
		case "error":
			return "error";
		default:
			return null;
	}
}

/**
 * Handles the previous step based on the onFailure value.
 * @param {number} currentIndex - The current index of the route
 * @param {Object} routes - The routes object
 * @param {string} onFailure - The value of onFailure
 * @returns {number|string|null} The previous index of the route. If onFailure is 'error', returns the index of the error route. If onFailure is 'countrySelection', returns the index of the country selection route. If onFailure is not recognized, returns null.
 */
function handlePrevStepOnFailure(currentIndex, routes, onFailure) {
	const errorRoute = Object.entries(routes).find(([key, value]) => value.includes("error"));
	switch (onFailure) {
		case "1":
			return parseInt(currentIndex) + 1;
		case "error":
			return parseInt(errorRoute[0]);
		case "docSelection":
			const countrySelectionRoute = findLastRoute(routes, currentIndex, "documents");
			return parseInt(countrySelectionRoute[0]);
		default:
			return null;
	}
}

/**
 * Handles the previous step based on the onBack value.
 * @param {number} currentIndex - The current index of the route
 * @param {string} onBack - The value of onBack
 * @returns {number|string|null} The previous index of the route. If onBack is '0', returns the previous index of the route. If onBack is not recognized, returns null.
 */
function handleStepOnBack(currentIndex, routes, onBack) {
	const currentIdx = parseInt(currentIndex);
	const backStep = parseInt(onBack);
	if (!isNaN(backStep)) {
		return currentIdx - backStep >= 0 ? currentIdx + backStep - 1 : null;
	} else {
		return null;
	}
}

/**
 * Finds the last occurrence of a route containing a specific substring within its value,
 * starting from the provided currentStep and searching backward to the initial step.
 *
 * @param {Object} routes - An object where keys represent step indices and values are route paths.
 * @param {number} currentStep - The current step index from which to start the reverse search.
 * @param {string} searchValue - The substring to search for within each route's value.
 * @returns {[string, string] | undefined} - The key-value pair of the last matching route as an array, or undefined if no match is found.
 *
 */
function findLastRoute(routes, currentStep, searchValue) {
	const routeEntries = Object.entries(routes);
	const slicedRoutes = routeEntries.slice(0, parseInt(currentStep) + 1).reverse();
	return slicedRoutes.find(([key, value]) => value.includes(searchValue));
}


/**
 * Finds the first route containing a specific substring within its value, starting from the
 * provided currentStep and searching forward to the end of the journey.
 *
 * @param {Object} routes - An object where keys represent step indices and values are route paths.
 * @param {number} currentStep - The step index from which to start the forward search.
 * @param {string} searchValue - The substring to search for within each route's value.
 * @returns {[string, string] | undefined} - The key-value pair of the first matching route as an array, or undefined if no match is found.
 */
function findNextRoute(routes, currentStep, searchValue) {
    const routeEntries = Object.entries(routes);
    return routeEntries
        .slice(parseInt(currentStep, 10))
        .find(([, value]) => value.includes(searchValue));
}

export {
    createOrchestration,
    regions,
    flowTypes,
    blockNames,
    journeyConfig,
    blockRoutes,
    findNextStep,
    findLastRoute,
    findNextRoute
};
